class ProductMediaSlider extends HTMLElement {
  constructor() {
    super();
    this.mainSwiper = null;
    this.thumbSwiper = null;

    this.image = this.dataset;
  }

  connectedCallback() {
    this.initSlider();
    this.applyInitialSlide();

    document.addEventListener('purchase-type-change', (e) => {
      this.switchToSlide(e.detail.type);
    });
  }

  // Apply correct slide on page load (subscription is checked by default)
  applyInitialSlide() {
    const defaultChecked = document.querySelector('input[name="purchaseOption"]:checked');
    const type = defaultChecked?.value === 'subscription' ? 'subscription' : 'onetime';
    // Wait for swiper to be ready
    setTimeout(() => this.switchToSlide(type), 100);
  }

  initSlider() {
    
    this.thumbSwiper = new Swiper(
      this.querySelector(".product-media-thumb-swiper"),
      {
        direction: window.innerWidth > 767 ? "vertical" : "horizontal",
        slidesPerView: 6,
        spaceBetween: 10,
        watchSlidesProgress: true,
        freeMode: true,
        breakpoints: {
          0:    { direction: "horizontal", slidesPerView: 5 },
          768:  { direction: "horizontal", slidesPerView: 4 },
          1024: { direction: "vertical",   slidesPerView: 4 },
          1440: { slidesPerView: 6 }
        },
        initialSlide: 0
      }
    );

    this.mainSwiper = new Swiper(
      this.querySelector(".product-media-main-swiper"),
      {
        slidesPerView: 1,
        spaceBetween: 10,
        effect: "slide",
        thumbs: { swiper: this.thumbSwiper },
        pagination: {
          el: this.querySelector(".product-hero-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector(".product-hero-next-button"),
          prevEl: this.querySelector(".product-hero-prev-button"),
        },
        initialSlide: 0
      }
    );
  }

  // Called externally to switch to the correct purchase-type slide
  switchToSlide(purchaseType) {
    if (!this.mainSwiper) return;

    const oppositeType = purchaseType === 'subscription' ? 'onetime' : 'subscription';

    if(this.image[purchaseType] != '') {
      this.querySelectorAll(`.product-media-slide--subscription`).forEach(slide => {
        slide.querySelector('img').src = this.image[purchaseType];
      });

      this.mainSwiper.slideTo(0, 300);
      this.thumbSwiper?.slideTo(0, 300);
    }  
  }
}

customElements.define("product-media-slider", ProductMediaSlider);